export const errorsConfig = {
  ERROR_REQUIRED: "Preencha esse campo.",
  "ERROR_EMAIL-INVALID":
    "E-mail inválido! Inclua um '@' no endereço de e-mail.",
  "ERROR_DESCRIPTION-REQUIRED": "Inclua uma descrição para cada arquivo.",
};
